"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormInputGroupContext", {
    enumerable: true,
    get: function() {
        return FormInputGroupContext;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormInputGroupContext = _react.default.createContext({
    inGroup: false,
    hasPrefix: false,
    hasSuffix: false,
    setHasPrefix: ()=>undefined,
    setHasSuffix: ()=>undefined,
    direction: "row"
});

//# sourceMappingURL=FormInputGroupContext.js.map